import React, { Component } from 'react'
import acc from 'accounting'

class FormChangeItem extends Component {
  _onSelectItem = () => {
    const { item, onSelectItem } = this.props
    if (item.get('taken_slots') === item.get('max_slots')) {
      return false
    }
    onSelectItem(this.props.item)
  }

  render() {
    const { item } = this.props

    return (
      <tr onTouchTap={this._onSelectItem}>
        <td>
          <code>{item.get('subject_code')}</code>
        </td>
        <td>
          <small>{item.get('section')}</small>
        </td>
        <td>
          <small>{item.get('subject_name')}</small>
        </td>
        <td>
          <small>{item.get('schedule')}</small>
        </td>
        <td className="text-right">{acc.formatNumber(item.get('units'), 1)}</td>
        <td>
          <small>{item.get('instructor_name')}</small>
        </td>
        <td>
          <span className="label label-default">
            {item.get('taken_slots')}/{item.get('max_slots')}
          </span>
        </td>
      </tr>
    )
  }
}

export default FormChangeItem



// WEBPACK FOOTER //
// ./src/containers/COR/hocs/withChangeSection/form-change-item.js